module.exports = __webpack_public_path__ + "img/activity.af2c2fa2.svg";